// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"52fa14d7","555":"7ba7e2cf","666":"1d782ea0","892":"16148938","984":"c92dc898"}[chunkId] + ".chunk.js";
};